import {gsap} from '../../_Global/js/global';
import {readingTime} from 'reading-time-estimator';

document.addEventListener('DOMContentLoaded', () => {
    const pageHeader = document.querySelector('.pageHeader');

    if (pageHeader) {
        const pageHeaderBlocks = pageHeader.querySelectorAll('.pageHeaderBlock');
        const pageReadTimes = pageHeader.querySelectorAll('.pageReadTime');

        const timeline = gsap.timeline();

        if (pageHeaderBlocks) {
            pageHeaderBlocks.forEach((item, index) => {
                timeline.fromTo(
                    item,
                    {
                        opacity: 0,
                        y: '100px',
                    },
                    {
                        duration: 1,
                        opacity: 1,
                        y: 0,
                        ease: 'power1.out',
                    },
                    index * 0.2,
                );
            });
        }

        // Calculate read time
        if (pageReadTimes) {
            // Find content, otherwise do nothing if not found
            let divText = document.querySelector('#article-content')?.textContent;
            if (!divText) return;

            // Calculate document read time
            const readTime = readingTime(divText, 250);

            pageReadTimes.forEach((item) => {

                if (readTime.minutes < 1) {
                    item.innerHTML = `< 1 min`;
                } else {
                    item.innerHTML = `${readTime.minutes} mins`;
                }

                
            });
        }
    }
});
